// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"texts-container__visuallyhidden--Povq0","focusable":"texts-container__focusable--BoQrJ","container":"texts-container__container--c6t_L"};